import type { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import type { ReactNode } from "react";
import { useState } from "react";
import type { LocationsAddResult } from "../Dialogs/LocationsAddDialog";
import { LocationsAddDialog } from "../Dialogs/LocationsAddDialog";
import type { LocationsSavingBehaviourType } from "../Types/LocationsSavingBehaviourType";

// Declarative replacement for the imperative useLocationsAddLocationDialog. Same
// callback contract: `callback` fires only when the wizard completes.
export function useLocationsAddLocationDialog(
  context: LocationContext,
  savingBehaviour: LocationsSavingBehaviourType,
  callback: (result: LocationsAddResult) => Promise<void>,
): { show: () => void; dialogs: ReactNode } {
  const [open, setOpen] = useState(false);
  const [openCount, setOpenCount] = useState(0);

  function show() {
    setOpenCount((count) => count + 1);
    setOpen(true);
  }

  const dialogs = (
    <LocationsAddDialog
      key={`locations-add-${openCount}`}
      open={open}
      onOpenChange={setOpen}
      context={context}
      savingBehaviour={savingBehaviour}
      onFinished={callback}
    />
  );

  return { show, dialogs };
}
